import React, {useState, useEffect} from "react";
import {Info} from "react-feather";
import "./CookiesCompiled.css";

export function Cookies() {
  const [fSelected, setFSelected] = useState(false);
  const [sSelected, setSSelected] = useState(false);
  const [nShow, setNShow] = useState(false);
  const [fShow, setFShow] = useState(false);
  const [sShow, setSShow] = useState(false);
  const [showCookies, setShowCookies] = useState(true);

  // Get a cookie by name
  const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(nameEQ) === 0) return false;
    }
    return true;
  };

  // Accept cookies
  const acceptCookies = () => {
    const date = new Date();
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000); // 1 year
    const expires = `; expires=${date.toUTCString()}`;
    document.cookie = `acceptedCookies=true${expires}; path=/`;
    document.cookie = `functionalCookies=${fSelected}${expires}; path=/`;
    document.cookie = `statisticalCookies=${sSelected}${expires}; path=/`;
    setShowCookies(false);
  };
  // Accept cookies
  const acceptAllCookies = () => {
    const date = new Date();
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000); // 1 year
    const expires = `; expires=${date.toUTCString()}`;
    document.cookie = `acceptedCookies=true${expires}; path=/`;
    document.cookie = `functionalCookies=true${expires}; path=/`;
    document.cookie = `statisticalCookies=true${expires}; path=/`;
    setShowCookies(false);
  };

  useEffect(() => {
    if (!getCookie("acceptedCookies")) {
      setShowCookies(false);
    }
  }, []);

  if (!showCookies) return null;

  return (
      <div
          className="fixed bottom-0 right-0 w-full md:w-144 bg-hgk-alto-gray border-t border-l border-t-hgk-downriver-blue border-l-hgk-downriver-blue z-300 rounded-tl-lg">
        <div className="grid grid-cols-3 gap-2 md:gap-5 p-3 md:p-5 md:p-10">
          <h1 className="col-span-3 text-xl p-0 m-0 text-white">
            Ova stranica upotrebljava kolačiće
          </h1>
          {/* Necessary Cookies Section */}
          <div className="col-span-1 flex items-center text-white">
            Nužni{" "}
            <Info
                className="text-white ml-2 cursor-pointer"
                size={20}
                onClick={() => {
                  setNShow(!nShow);
                  setFShow(false);
                  setSShow(false);
                }}
            />
          </div>
          <div className="col-span-2 flex flex-row justify-between">
            <button
                className="relative disabled flex flex-col justify-center items-center px-3 md:px-10 rounded whitespace-nowrap ml-2 text-hgk-downriver-blue bg-white border border-hgk-alto-gray h-10 cursor-auto opacity-40"
                disabled
            >
              Prihvaćam
            </button>
            <button
                className="relative disabled flex flex-col justify-center items-center px-3 md:px-10 rounded whitespace-nowrap ml-2 text-hgk-downriver-blue bg-white border border-hgk-alto-gray h-10 cursor-auto opacity-40"
                disabled
            >
              Ne prihvaćam
            </button>
          </div>
          {nShow && (
              <div className="col-span-3 transition-all text-white-blue">
                <span className="font-bold">Nužni kolačići</span> - omogućuju
                interakciju s uslugom ili internetskom lokacijom kako biste mogli
                pristupiti osnovnim značajkama za pružanje te usluge. Odnose se na
                zatraženu uslugu kao što je, npr. identifikator sesije trenutačnog
                posjeta.
              </div>
          )}
          {/* Functional Cookies Section */}
          <div className="col-span-1 flex items-center text-white">
            Funkcionalni{" "}
            <Info
                className="text-white ml-2 cursor-pointer"
                size={20}
                onClick={() => {
                  setFShow(!fShow);
                  setNShow(false);
                  setSShow(false);
                }}
            />
          </div>
          <div className="col-span-2 flex flex-row justify-between">
            <button
                className={`relative flex flex-col justify-center items-center px-3 md:px-10 rounded whitespace-nowrap transition-all hover:shadow-soft ml-2 border border-hgk-alto-gray h-10 ${
                    fSelected
                        ? "text-hgk-downriver-blue bg-white"
                        : "bg-hgk-downriver-blue text-white"
                }`}
                onClick={() => setFSelected(true)}
            >
              Prihvaćam
            </button>
            <button
                className={`relative flex flex-col justify-center items-center px-3 md:px-10 rounded whitespace-nowrap transition-all hover:shadow-soft ml-2 border border-hgk-alto-gray h-10 ${
                    !fSelected
                        ? "text-hgk-downriver-blue bg-white"
                        : "bg-hgk-downriver-blue text-white"
                }`}
                onClick={() => setFSelected(false)}
            >
              Ne prihvaćam
            </button>
          </div>
          {fShow && (
              <div className="col-span-3 transition-all text-white">
                <span className="font-bold">Funkcionalni kolačići</span> -
                omogućuju internetskoj stranici pružanje poboljšane funkcionalnosti
                i personalizaciju, npr. pamćenje jezika na kojem se prikazuje
                sadržaj stranica toga internetskog mjesta.
              </div>
          )}
          {/* Statistical Cookies Section */}
          <div className="col-span-1 flex items-center text-white">
            Statistički{" "}
            <Info
                className="text-white ml-2 cursor-pointer"
                size={20}
                onClick={() => {
                  setSShow(!sShow);
                  setNShow(false);
                  setFShow(false);
                }}
            />
          </div>
          <div className="col-span-2 flex flex-row justify-between">
            <button
                className={`relative flex flex-col justify-center items-center px-3 md:px-10 rounded whitespace-nowrap transition-all hover:shadow-soft ml-2 border border-hgk-alto-gray h-10 ${
                    sSelected
                        ? "text-hgk-downriver-blue bg-white"
                        : "bg-hgk-downriver-blue text-white"
                }`}
                onClick={() => setSSelected(true)}
            >
              Prihvaćam
            </button>
            <button
                className={`relative flex flex-col justify-center items-center px-3 md:px-10 rounded whitespace-nowrap transition-all hover:shadow-soft ml-2 border border-hgk-alto-gray h-10 ${
                    !sSelected
                        ? "text-hgk-downriver-blue bg-white"
                        : "bg-hgk-downriver-blue text-white"
                }`}
                onClick={() => setSSelected(false)}
            >
              Ne prihvaćam
            </button>
          </div>
          {sShow && (
              <div className="col-span-3 transition-all text-white">
                <span className="font-bold">Statistički kolačići</span> - ove
                stranice koriste Google Analytics kolačiće koji omogućuju analiziranje
                posjećenosti. Pružatelj te usluge je Google LLC. Informacije koje
                Google Analytics kolačići generiraju o vašem načinu korištenja ovih
                stranica, među kojima je i IP adresa s koje ste pristupili stranicama,
                prenose se na poslužitelj tvrtke Google LLC i tamo pohranjuju.
              </div>
          )}
        </div>
        <div className="flex flex-row justify-center gap-5 my-3 md:mb-5 md:px-5">
          <button
              className="relative flex flex-col justify-center items-center px-3 md:px-8 rounded-lg text-hgk-downriver-blue bg-white border border-hgk-alto-gray h-10 hover:bg-hgk-emperor-gray hover:text-white"
              onClick={acceptCookies}
          >
            Prihvaćam odabrane
          </button>
          <button
              className="relative flex flex-col justify-center items-center px-3 md:px-10 rounded-lg text-hgk-downriver-blue bg-white border border-hgk-alto-gray h-10 hover:bg-hgk-emperor-gray hover:text-white"
              onClick={acceptAllCookies}
          >
            Prihvaćam sve
          </button>
        </div>
        <p className="md:mx-5 mb-5 text-white px-3">
          Na ovoj mrežnoj stranci koriste se kolačići. Molimo Vas da pročitate{" "}
          <a className="underline" href="/politika-privatnosti">
            Obavijest o kolačićima
          </a>
          .
        </p>
      </div>
  )
      ;
}
